import { render, staticRenderFns } from "./Criancas.vue?vue&type=template&id=b510d81e"
import script from "./Criancas.vue?vue&type=script&lang=js"
export * from "./Criancas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports